import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1920px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  background-color: var(--white);
  margin: 30px 0px 80px 0px;
  position: relative;

  // Cotizador Container
  .cotizadorContainer {
    margin-left: 13vw;
    z-index: 99;
  }

  // Cotizador Titles
  .cotizadorContainer h1,
  .cotizadorContainer h2 {
    width: 100%;
    color: var(--black);
    font-family: "Raleway", sans-serif;
    font-style: normal;
    letter-spacing: -0.015em;
    margin: 0px 0px 12px 0px;
  }

  .cotizadorContainer h1 {
    font-weight: bold;
    font-size: 2.6em;
  }

  .cotizadorContainer h3 {
    font-weight: 600;
    font-size: 1.4em;
    margin: 0px 0px 60px 0px;
  }

  // Formulario Container
  .formularioContainer {
    max-width: 680px;
    min-width: 672px;
    padding: 27px 30px 27px 30px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    flex-direction: row;
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    border-radius: 12px;
    background-color: var(--white);
  }

  // Formulario
  .formularioContainer form {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 0px 0px 0px 0px;
  }

  // Input Range Container
  .inputRangeContainer {
    width: 100% !important;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
  }

  // Input Range Text
  .inputRangeContainer p {
    color: var(--black);
    font-family: "Raleway", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    margin: 0px 0px 11px 0px;
  }

  .inputRangeContainer p:nth-child(2) {
    color: var(--orange);
    font-weight: 700;
  }

  .inputRangeContainer p:nth-child(4),
  .inputRangeContainer p:nth-child(5) {
    font-size: 14px;
    color: var(--lightgray);
    margin: 5px 0px 0px 0px;
  }

  // Input Range Input
  .inputRangeContainer input {
    width: 100%;
    padding: 0px 0px 0px 0px;
    margin: 4px;
    -webkit-appearance: none;
    --value: 40000;
    --min: 20000;
    --max: 500000;
  }

  .inputError {
    border: 1px solid red !important;
  }

  .inputRangeContainer input:focus {
    outline: none;
  }

  .inputRangeContainer input::-webkit-slider-runnable-track {
    background: var(--lightorange2);
    -webkit-appearance: none;
    border-radius: 25px;
    width: 100%;
    height: 8px;
    cursor: pointer;
    box-shadow: none;
  }

  .inputRangeContainer input::-webkit-slider-thumb {
    margin-top: -4px;
    width: 18px;
    height: 18px;
    background-color: var(--white);
    border: 2.5px solid var(--orange);
    border-radius: 50px;
    cursor: pointer;
    -webkit-appearance: none;
  }

  input.sliderProgress {
    --range: calc(var(--max) - var(--min));
    --ratio: calc((var(--value) - var(--min)) / var(--range));
    --sx: calc(0.5 * 2em + var(--ratio) * (100% - 2em));
  }

  input.sliderProgress::-webkit-slider-runnable-track {
    background: linear-gradient(var(--orange), var(--orange)) 0 / var(--sx) 100%
        no-repeat,
      var(--lightorange2);
  }

  // Idem para Firefox
  .inputRangeContainer input::-moz-range-track {
    background: var(--lightorange2);
    border: 0;
    border-radius: 25px;
    width: 100%;
    height: 8px;
    cursor: pointer;
  }

  .inputRangeContainer input::-moz-range-progress {
    background: var(--orange);
    border: 0;
    border-radius: 25px;
    height: 8px;
  }

  .inputRangeContainer input::-moz-range-thumb {
    margin-top: -4px;
    width: 16px;
    height: 16px;
    background-color: var(--white);
    border: 2.5px solid var(--orange);
    border-radius: 50px;
    cursor: pointer;
    -webkit-appearance: none;
  }

  // Other Inputs Container
  .otherInputsContainer {
    width: 100%;
    margin: 22px 0px 0px 0px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
  }

  // Input Container
  .otherInputsContainer .inputContainer, .otherInputsContainer .selectContainer {
    width: 48%;
    position: relative;
    margin: 35px 0px 0px 0px;
  }


  // Input, Select and Label
  .otherInputsContainer .inputContainer input,
  .otherInputsContainer .inputContainer label,
  .otherInputsContainer .selectContainer select,
  .otherInputsContainer .selectContainer label {
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
  }

  // Inputs and Select
  .otherInputsContainer .inputContainer input,
  .otherInputsContainer .selectContainer select {
    width: 100%;
    height: 35px;
    padding: 0px 15px 0px 15px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: "Raleway", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    color: var(--lightgray);
    border: 1px solid var(--lightgray);
    -webkit-appearance: none;
    box-shadow: 0;
    transition: 0.2s all;
    border-radius: 3px;
  }

  // Label
  .otherInputsContainer .inputContainer label,
  .otherInputsContainer .selectContainer label {
    position: absolute;
    top: 0.95em;
    left: 0;
    margin: 0px 0px 0px 15px;
    line-height: 1;
    font-size: 0.75em;
    font-weight: 400;
    color: var(--lightgray);
    cursor: text;
    z-index: 100;
  }

  // Input and Select On Focus Label
  .otherInputsContainer .inputContainer input:focus + label,
  .otherInputsContainer .selectContainer select:focus + label {
    top: -0.6em;
    background-color: var(--white);
    padding: 0px 6px 0px 6px;
    margin: 0px 0px 0px 10px; 
    font-weight: 600;
    font-size: 0.7em;
    color: var(--orange) !important;
  }

  // Inputs and Select Focus
  .otherInputsContainer .inputContainer input:focus,
  .otherInputsContainer .selectContainer select:focus {
    border: 1px solid var(--orange);
    outline: none;
  }

  // Label Top
  .labelTop {
    top: -0.6em !important;
    background-color: var(--white);
    padding: 0px 6px 0px 6px;
    margin: 0px 0px 0px 10px !important; 
    font-weight: 600 !important;
    font-size: 0.7em !important;
    color: var(--lightgray) !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  #inputNombreContainer,
  #inputApellidoContainer {
    width: 156px;
    max-width: 156px;
    margin: 0px 0px 23px 0px;
  }

  #inputEmailContainer {
    width: 330px;
    max-width: 330px;
    margin: 0px 0px 23px 0px;
  }

  #inputCodigoAreaContainer {
    width: 109px;
    max-width: 109px;
    margin: 0px 0px 20px 0px;
  }

  #inputTelefonoContainer {
    width: 203px;
    max-width: 203px;
    margin: 0px 0px 20px 0px;
  }

  // Select Container
  .selectContainer {
    position: relative;
    height: 35px;
    width: 100% !important;
    max-width: 330px;
    margin: 0px 0px 20px 0px !important;
  }

  // Select
  .selectContainer select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: inline-block;
    width: 100%;
    padding: 0px 15px 0px 15px;
    margin: 0px 0px 0px 0px;
    height: 100%;
    cursor: pointer;
    outline: 0;
    border: 1px solid var(--lightgray);
    font-family: "Raleway", sans-serif;
    font-style: normal;
    font-weight: normal;
    color: var(--lightgray);
    position: relative;
    transition: all 0.25s ease;
    z-index: 100;
    background-color: transparent;
    border-radius: 0;
    -webkit-appearance: none;
    box-shadow: 0;
    border-radius: 3px;
    font-size: 0.75em;
  }

  // Select Arrow
  .selectContainer i {
    position: absolute;
    right: 15px;
    top: calc(50% - 7px);
    width: 7px;
    height: 7px;
    display: block;
    border-left: 3px solid var(--lightgray);
    border-bottom: 3px solid var(--lightgray);
    transform: rotate(-45deg);
    z-index: 99;
    border-radius: 10%;
  }

  // Select default arrow
  .selectContainer select::-ms-expand {
    display: none;
  }

  // Select Option
  .selectContainer select * {
    color: var(--black);
  }

  // Cotizar Button
  a {
    margin-top: 7px;
    padding: 6px 18px 6px 18px;
    border-radius: 6px;
    border: 0px solid;
    color: var(--white);
    font-family: "Raleway", sans-serif;
    font-size: 1em;
    font-style: normal;
    font-weight: 600;
    background-color: var(--orange);
    cursor: pointer;
    transition: 0.2s;
    text-decoration: none;
  }

  a:hover {
    background-color: var(--lightorange);
  }

  .buttonsContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    margin: 7px 0px 0px 0px;
  }

  .buttonsContainer a {
    background-color: white;
    color: var(--green);
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    font-family: "Raleway", sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
  }

  .buttonsContainer a span {
    font-size: 17px;
    margin: 3px 7px 0px 0px;
  }

  .buttonsContainer button {
    padding: 8px 27px 8px 27px;
    border-radius: 6px;
    border: 0px solid;
    color: var(--white);
    font-family: "Raleway", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    background-color: var(--orange);
    cursor: pointer;
    transition: 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
  }

  button img {
    max-width: 17px;
    margin-left: 10px;
    transition: 0.4s all;
  }

  .buttonsContainer a:hover {
    color: var(--black);
  }

  button:hover {
    background-color: var(--lightorange);
  }

  button:hover > img {
    transform: translate(15px); /* Equivalente a translateX(10px) */
  }

  // Ilustration Container
  .ilustrationContainer {
    width: 780px;
    min-width: 780px;
    margin-right: 36px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    position: absolute;
    right: 0;
  }

  // Ilustration
  .ilustrationContainer img {
    display: block;
    width: 100%;
  }

  // 1550px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1550}) {
    align-items: flex-end;
    align-content: flex-end;
    margin: 30px 0px 30px 0px;

    // Formulario Container
    .formularioContainer {
      max-width: 400px;
      min-width: 400px;
    }

    // Input Range Input
    .inputRangeContainer input {
      margin: 4px 0px 4px 0px;
    }

    // Inputs
    .otherInputsContainer .inputContainer input {
      padding: 0px 10px 0px 10px;
    }

    #inputNombreContainer,
    #inputApellidoContainer {
      width: 191px;
      max-width: 191px;
      margin: 0px 0px 15px 0px;
    }

    #inputEmailContainer {
      width: 100%;
      max-width: 100%;
      margin: 0px 0px 15px 0px;
    }

    #inputCodigoAreaContainer {
      width: 108px;
      max-width: 108px;
    }

    #inputTelefonoContainer {
      width: 273px;
      max-width: 273px;
    }

    // Select Container
    .selectContainer {
      width: 100%;
      max-width: 100%;
      margin: 15px 0px 15px 0px;
    }

    // Select
    .selectContainer select {
      padding: 0px 10px 0px 10px;
    }

    // Ilustration Container
    .ilustrationContainer {
      width: 700px;
      min-width: 700px;
    }
  }

  // 1160px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1160}) {
    justify-content: center;
    width: 100%;

    // Cotizador Container
    .cotizadorContainer {
      margin: 0px 0px 0px 0px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }

    // Cotizador Titles
    .cotizadorContainer h1 {
      text-align: center;
      font-size: 2.3em;
      margin: 0px 0px 3px 0px;
    }

    .cotizadorContainer h3 {
      margin: 0px 0px 39px 0px;
      text-align: center;
      font-size: 1.3em;
    }

    // Formulario Container
    .formularioContainer {
      margin: 245px 0px 0px 0px;
      max-width: 627px;
      padding: 20px 20px 20px 20px;
    }

    // Inputs
    .otherInputsContainer .inputContainer input {
      padding: 0px 15px 0px 15px;
    }

    #inputNombreContainer,
    #inputApellidoContainer {
      width: 144px;
      max-width: 144px;
      margin: 0px 0px 15px 0px;
    }

    #inputEmailContainer {
      width: 307px;
      max-width: 307px;
      margin: 0px 0px 15px 0px;
    }

    #inputCodigoAreaContainer {
      width: 99px;
      max-width: 99px;
    }

    #inputTelefonoContainer {
      width: 190px;
      max-width: 190px;
    }

    // Select Container
    .selectContainer {
      width: 309px;
      max-width: 309px;
      margin: 0px 0px 20px 0px;
    }

    // Select
    .selectContainer select {
      padding: 0px 15px 0px 15px;
    }

    // Ilustration
    .ilustrationContainer {
      top: 90px;
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin: 0px 0px 0px 0px;
      display: flex;
      justify-content: center;
    }

    // Ilustration
    .ilustrationContainer img {
      width: 500px;
      margin: 0px 45px 0px 0px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Formulario Container
    .formularioContainer {
      margin: 215px 0px 0px 0px;
      max-width: 400px;
      min-width: 400px;
    }

    .titleFormularioContainer {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: row;
    }

    // Input Range Input
    .inputRangeContainer input {
      margin: 3px 0px 3px 0px;
    }

    // Inputs
    .otherInputsContainer .inputContainer input {
      padding: 0px 10px 0px 10px;
      height: 32px;
    }

    #inputNombreContainer,
    #inputApellidoContainer {
      width: 191px;
      max-width: 191px;
      margin: 0px 0px 12px 0px;
    }

    #inputEmailContainer {
      width: 100%;
      max-width: 100%;
      margin: 0px 0px 12px 0px;
    }

    #inputCodigoAreaContainer {
      width: 108px;
      max-width: 108px;
    }

    #inputTelefonoContainer {
      width: 273px;
      max-width: 273px;
    }

    // Select Container
    .selectContainer {
      width: 100%;
      max-width: 100%;
      margin: 12px 0px 12px 0px;
      height: 29px;
    }

    // Select
    .selectContainer select {
      padding: 0px 10px 0px 10px;
      height: 29px;
    }
  }

  // 700px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet700}) {
    button {
      margin-top: 7px;
      padding: 9px 0px 9px 0px;
      width: 100%;
    }

    // Ilustration
    .ilustrationContainer {
      display: flex;
      justify-content: center;
    }

    .buttonsContainer {
      flex-direction: column-reverse;
    }

    .buttonsContainer a {
      margin-top: 15px;
    }
  }

  // 525px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile525}) {
    margin: 10px 0px 80px 0px;

    // Cotizador Titles
    .cotizadorContainer h1,
    .cotizadorContainer h3 {
      width: 90%;
    }

    .cotizadorContainer h3 {
      width: 60%;
    }

    // Ilustration
    .ilustrationContainer {
      width: 100%;
      max-width: 100%;
      min-width: none !important;
      top: 130px;
    }

    // Ilustration
    .ilustrationContainer img {
      width: 100%;
      margin: 0px 0px 0px 0px;
    }
  }

  // 470px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile470}) {
    // Formulario Container
    .formularioContainer {
      max-width: 320px;
      min-width: 320px;
    }

    // Cotizador Titles
    .cotizadorContainer h1 {
      width: 80%;
    }

    .cotizadorContainer h3 {
      width: 70%;
      margin: 0px 0px 20px 0px;
    }

    // Inputs
    #inputNombreContainer,
    #inputApellidoContainer {
      width: 130px;
      max-width: 130px;
    }

    #inputCodigoAreaContainer {
      width: 90px;
      max-width: 90px;
    }

    #inputTelefonoContainer {
      width: 170px;
      max-width: 170px;
    }
  }

  // 390px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile390}) {
    // Formulario Container
    .formularioContainer {
      max-width: 270px;
      min-width: 270px;
    }

    // Cotizador Titles
    .cotizadorContainer h1,
    .cotizadorContainer h3 {
      width: 90%;
    }

    .cotizadorContainer h3 {
      margin: 0px 0px 0px 0px;
    }

    // Inputs
    #inputNombreContainer,
    #inputApellidoContainer {
      width: 100%;
      max-width: 100%;
    }

    #inputCodigoAreaContainer {
      width: 25%;
      max-width: 25%;
    }

    #inputTelefonoContainer {
      width: 55%;
      max-width: 55%;
    }
  }

  // 350px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile350}) {
    // Cotizador Titles
    .cotizadorContainer h1,
    .cotizadorContainer h3 {
      width: 95%;
    }

    .cotizadorContainer h1 {
      font-size: 2.4em;
    }
  }

  // 340px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile340}) {
    // Formulario Container
    .formularioContainer {
      max-width: 240px;
      min-width: 240px;
      margin: 200px 0px 0px 0px;
    }

    .cotizadorContainer h1 {
      font-size: 2em;
    }

    .cotizadorContainer h3 {
      font-size: 1.2em;
    }

    #inputCodigoAreaContainer {
      width: 24%;
      max-width: 24%;
    }

    #inputTelefonoContainer {
      width: 53%;
      max-width: 53%;
    }
  }

  // 310px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile310}) {
    // Formulario Container
    .formularioContainer {
      max-width: 220px;
      min-width: 220px;
    }

    #inputCodigoAreaContainer {
      width: 23%;
      max-width: 23%;
    }

    #inputTelefonoContainer {
      width: 52%;
      max-width: 52%;
    }
  }

  // 280px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile280}) {
    // Formulario Container
    .formularioContainer {
      max-width: 200px;
      min-width: 200px;
    }

    #inputCodigoAreaContainer {
      width: 100%;
      max-width: 100%;
      margin: 0px 0px 12px 0px;
    }

    #inputTelefonoContainer {
      width: 100%;
      max-width: 100%;
    }
  }
`;

export default Container;
